<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md">
      <h2 class="text-lg font-semibold dark:text-gray-100 mb-2">Save phone to the requester's record?</h2>
      <p class="text-sm text-gray-700 dark:text-gray-200 mb-4">
        You entered <span class="font-semibold">{{ newPhone }}</span> as the phone for this ticket.
        Should this also be saved as the requester's primary work phone in the Address Book?
      </p>
      <ul class="text-xs text-gray-600 dark:text-gray-300 mb-4 list-disc list-inside space-y-1">
        <li><strong>Yes</strong> — overwrite the requester's Address Book work phone and save this ticket.</li>
        <li><strong>No</strong> — keep this number on the ticket only; leave the requester's Address Book unchanged.</li>
      </ul>
      <div class="flex justify-end space-x-2 mt-2">
        <button @click="$emit('decision', false)"
          class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded dark:bg-gray-600 dark:hover:bg-gray-500">
          No, ticket only
        </button>
        <button @click="$emit('decision', true)"
          class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded dark:bg-green-400 dark:hover:bg-green-600">
          Yes, update Address Book
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: { type: Boolean, default: false },
    newPhone: { type: String, default: '' },
  },
  emits: ['decision'],
};
</script>
